var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emoji",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 17,
    width: 62,
    height: 38,
    fill: "#d22f27",
    id: "rect838"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 34,
    r: 1.75,
    fill: "#f1b31c",
    id: "circle840"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 1.75,
    fill: "#f1b31c",
    id: "circle842"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 31,
    r: 1.75,
    fill: "#f1b31c",
    id: "circle844"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 26,
    r: 1.75,
    fill: "#f1b31c",
    id: "circle846"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f1b31c",
    stroke: "#f1b31c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "13.528 32.445 16 24.445 18.473 32.445 12 27.5 20 27.5 13.528 32.445",
    id: "polygon848"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 17,
    width: 62,
    height: 38,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    id: "rect851"
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "29.06674194px",
      lineHeight: "125%",
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "0.7266686px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    x: 33.789528,
    y: 45.838863,
    id: "text4566"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan4564",
    x: 33.789528,
    y: 45.838863,
    style: {
      strokeWidth: "0.7266686px"
    }
  }, "\u7E41")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.7e57d97664ad4375f4c6985c8fd09fa5.svg";
export { ForwardRef as ReactComponent };